module.exports = __webpack_public_path__ + "img/1F1F1-1F1E7.63a510dc.svg";